import { Grouping } from "devextreme-react/data-grid";
import { HamListState, StartLoadingActionPayload, UpdateHamActionPayload } from "../rootReducerTypes";
import {
    UpdateHamAction
    , StartLoadinAction
    , RequestErrorAction
    , FetchInitAction
    , SetCurrentPageAction
    , UpdateQueryAction
    , HamListActionTypes, UPDATE_HAM, START_LOADING, REQUEST_ERROR, FETCH_INIT, SET_CURRENT_PAGE, UPDATE_QUERY, SetPageSizeAction, SET_PAGE_SIZE, UpdateSortByAction, UPDATE_SORTBY, UPDATE_SEARCH_HAM, UpdateSearchHamAction, ChangeGroupingAction, CHANGE_GROUPING, SetExpandedGroupsAction, SET_EXPANDED_GROUPS, SetEmployeesAction
} from "../reducersAndActionsType/hamListActionAndReducerTypes";

export function updateHamEntries(updateHamActionPayload: UpdateHamActionPayload): UpdateHamAction {
    return {
        type: UPDATE_HAM,
        updateHamActionPayload,
    };
}

export function startLoading(startLoadingActionPayload: StartLoadingActionPayload): StartLoadinAction {
    return {
        type: START_LOADING,
        startLoadingActionPayload,
    };
}

export function requestError(): RequestErrorAction {
    return {
        type: REQUEST_ERROR,
    };
}
export function fetchInit(): FetchInitAction {
    return {
        type: FETCH_INIT,
    };
}
export function setCurrentPage(currentPage: number): SetCurrentPageAction {
    return {
        type: SET_CURRENT_PAGE,
        currentPage
    };
}
export function setPageSize(pageSize: number): SetPageSizeAction {
    return {
        type: SET_PAGE_SIZE,
        pageSize
    };
}
export function updateQuery(lastQuery: string): UpdateQueryAction {
    return {
        type: UPDATE_QUERY,
        lastQuery
    };
}

export function updateSortBy(payload: string): UpdateSortByAction {
    return {
        type: UPDATE_SORTBY,
        sortBy: payload
    };
}


export function updateSearchHamList(payload: string): UpdateSearchHamAction {
    return {
        type: UPDATE_SEARCH_HAM,
        searchText: payload
    };
}

export function changeGrouping(payload: Grouping[]): ChangeGroupingAction {
    return {
        type: CHANGE_GROUPING,
        grouping: payload
    };
}

export function setExpandedGroups(payload: string[]): SetExpandedGroupsAction {
    return {
        type: SET_EXPANDED_GROUPS,
        expandedGroups: payload
    };
}

export function setEmployees(payload: any[]): SetEmployeesAction {
    return {
        type: "SET_EMPLOYEES",
        employees: payload
    };
}

export default function hamListReducer(state: HamListState = initialState, action: HamListActionTypes): HamListState {
    switch (action.type) {
        case 'UPDATE_HAM':
            return {
                ...state,
                // hamentries: action.updateHamActionPayload.hamEntries,
                // totalCount: action.updateHamActionPayload.totalCount,
                // skip: action.updateHamActionPayload.skip,
                loading: false,
                tempGrouping: null,
                tempExpandedGroups: null,
            };
        case 'START_LOADING':
            return {
                ...state,
                hamListParameter: action.startLoadingActionPayload,
            };
        case 'REQUEST_ERROR':
            return {
                ...state,
                loading: false,
            };
        case 'FETCH_INIT':
            return {
                ...state,
                loading: true,
            };
        case 'SET_CURRENT_PAGE':
            return {
                ...state,
                currentPage: action.currentPage
            };
        case 'UPDATE_QUERY':
            return {
                ...state,
                lastQuery: action.lastQuery,
            };
        case 'SET_PAGE_SIZE':
            return {
                ...state,
                pageSize: action.pageSize,
            };
        case 'UPDATE_SORTBY':
            return {
                ...state,
                sortBy: action.sortBy,
            };
        case 'UPDATE_SEARCH_HAM':
            return {
                ...state,
                searchText: action.searchText,
            };
        case 'CHANGE_GROUPING':
            return {
                ...state,
                grouping: action.grouping,
                tempGrouping: state.tempGrouping === null ? state.grouping : state.tempGrouping,
                tempExpandedGroups: state.expandedGroups,
            };
        case 'SET_EXPANDED_GROUPS':
            return {
                ...state,
                expandedGroups: action.expandedGroups,
            };
        case 'SET_EMPLOYEES':
            return {
                ...state,
                employees: action.employees,
            };
        default:
            return state;
    }
}

export const initialState: HamListState = {
    hamEntries: [],
    hamListParameter: { requestedSkip: 0, take: 20 },
    totalCount: 0,
    loading: false,
    lastQuery: '',
    currentPage: 0,
    pageSize: 25,
    sortBy: '',
    searchText: '',
    grouping: [],
    expandedGroups: [],
    tempGrouping: null,
    tempExpandedGroups: null,
    employees: [],
};